// [init]

export default {


	namespaced: true,

	state: {
		// Listing of all scopes ( Array )
		scopeList: [],

		// Current Scope being manipulated ( viewed or edited ) ( Object )
        status: '',
        activeScope: {}
	},

	mutations: {

		// Update scopeList with new list
		// @params: Array
		updateScopeList( state, newList ) {
			state.scopeList = newList;
		},

		// Add a option into scopeList
		addScope( state, newScope ) {
			state.scopeList.push( newScope );
		},

		// Delete a scope from scopeList
		// @params: identifier (String)
		deleteScope( state, identifier ) {
			state.scopeList = state.scopeList.filter(option => {
				return option.id != identifier;
			});
		},

		// Update the current active Scope object
		// @params: newActiveScope (Object)
		updateActiveScope( state, newActiveScope ) {
			state.activeScope = newActiveScope;
		},

		// Change status of optionForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		},

		resetState( state ) {
			state.status = '';
			state.activeScope = {};
		}

	},

	actions: {
		
		/* 
		*  /GET scopes API
		*  Get all scopes from the server
		*  @return: Array
		*/
		getScopes( { commit, state } ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/cms/scope-of-work',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateScopeList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id scopes API
		*  Get a single option from the server
		*  @params: Array (due to vuex limitations)
		*  [0]: identifier (String)
		*  [1]: action (String: view/edit)
		*  @return: Object
		*/
		getSingleScope( { commit, state }, params ) {

			const identifier = params[0];
			const action = params[1];

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: 'cms/scope-of-work/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateActiveScope', response.data );
					commit( 'updateStatus', action );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /POST scopes API
		*  Add a new option to the server
		*  @params: Object (scopes data)
		*  @return: Object
		*/
		addScope( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {
				const postData = {
					clientname: data.clientname,
					content: data.content,
					profilePhoto: data.profilePhoto,
				};

				global.axios.request({
					method: 'post',
					url: '/cms/scope-of-work/addnew',
					validateStatus: ( status ) => { return status == 201; },
					data: postData
				})
				.then(response => {
					commit( 'addScope', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});


		},

		/* 
		*  /POST/:id scopes API
		*  Edits an existing option into the server
		*  @params: Object (option data)
		*  @return: Object
		*/
		editScope( { commit, state }, data ) {

			return new Promise ((resolve, reject ) => {
				const postData = {
					name: data.name,
					estimated_time: data.estimated_time,
					icon: data.icon,
					content: data.content
				};

				global.axios.request({
					method: 'post',
					url: 'cms/scope-of-work/' + data.id + '/update',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					commit( 'addScope', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /DELETE/:id scopes API
		*  Removes an existing option into the server
		*  @params: identifier (String)
		*  @return: 200 OK
		*/
		deleteScope( { commit, state }, identifier ) {

			return new Promise ((resolve, reject ) => {

				global.axios.request({
					method: 'post',
					url: 'cms/scope-of-work/' + identifier + '/delete',
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'deleteScope', identifier );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		}

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/ScopeOfWorks.js